import React, { useEffect } from "react";
import "./App.css";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./home/HomePage";
import LoginPage from "./login/LoginPage";
import { useNavigate } from "react-router-dom";

function RedirectIfLoggedIn() {
  const navigate = useNavigate();
  useEffect(() => {
    const name = localStorage.getItem("name");
    const room = localStorage.getItem("room");
    if (name && room) {
      navigate(`/home?room=${room}&name=${name}`);
    } else {
      navigate("/login");
    }
  }, [navigate]);

  return null;
}
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
      </Routes>
      <RedirectIfLoggedIn />
    </Router>
  );
}

export default App;
